const CftBagCore = (() => {
  const activeCart = cart => ({...cart, items: cart.items.filter(item => item.quantity > 0)});
  const identity = item => JSON.stringify([item.variant_id || item.id,
    item.selling_plan_allocation?.selling_plan?.id || null,
    Object.entries(item.properties || {}).sort(([a], [b]) => a.localeCompare(b))]);
  const fingerprint = cart => JSON.stringify([cart.currency, cart.total_price, cart.total_discount,
    cart.items.map(item => [identity(item), item.key, item.quantity]),
    cart.note, Object.entries(cart.attributes || {}).sort(), codes(cart)]);
  function codes(cart) {
    const applications = [...(cart.cart_level_discount_applications || []),
      ...cart.items.flatMap(item => (item.line_level_discount_allocations || []).map(a => a.discount_application))];
    return [...new Set(applications.filter(a => a?.type === 'discount_code').map(a => a.title))];
  }
  function input(cart, selected, country) {
    const items = cart.items.filter(item => item.quantity > 0 && selected.has(identity(item)));
    if (!items.length) throw new Error('Choose an item to check out.');
    if (items.some(item => item.parent_relationship || item.item_components?.length))
      throw new Error('Please select all items to check out this bundle.');
    return {
      lines: items.map(item => ({
        merchandiseId: `gid://shopify/ProductVariant/${item.variant_id || item.id}`,
        quantity: item.quantity,
        attributes: Object.entries(item.properties || {}).map(([key, value]) => ({key, value: String(value)})),
        ...(item.selling_plan_allocation ? {sellingPlanId: `gid://shopify/SellingPlan/${item.selling_plan_allocation.selling_plan.id}`} : {})
      })),
      discountCodes: codes(cart),
      attributes: Object.entries(cart.attributes || {}).map(([key, value]) => ({key, value: String(value)})),
      note: cart.note || '', buyerIdentity: {countryCode: country}
    };
  }
  // Shopify 的行分配金额已包含订单级优惠；不再叠加整车优惠或运费。
  function amounts(quote, currency) {
    const money = amount => {
      if (amount.currencyCode !== currency) throw new Error('Please refresh your bag to update the currency.');
      const match = /^(\d+)(?:\.(\d{1,6}))?$/.exec(amount.amount);
      if (!match) throw new Error('Unable to calculate this selection.');
      return BigInt(match[1]) * 1000000n + BigInt((match[2] || '').padEnd(6, '0'));
    };
    const subtotal = quote.lines.nodes.reduce((n, item) => n + money(item.cost.subtotalAmount), 0n);
    const discounts = quote.lines.nodes.reduce((n, item) => n + item.discountAllocations
      .filter(a => a.targetType === 'LINE_ITEM').reduce((sum, a) => sum + money(a.discountedAmount), 0n), 0n);
    if (discounts > subtotal) throw new Error('Unable to calculate this selection.');
    return {subtotal: Number(subtotal) / 1000000, discounts: Number(discounts) / 1000000,
      total: Number(subtotal - discounts) / 1000000,
      quantity: quote.lines.nodes.reduce((n, item) => n + item.quantity, 0)};
  }
  const query = `mutation SelectedBag($input: CartInput!, $first: Int!) {
    cartCreate(input: $input) {
      cart {
        checkoutUrl totalQuantity
        lines(first: $first) { nodes {
          quantity merchandise { ... on ProductVariant { id } }
          cost { subtotalAmount { amount currencyCode } }
          discountAllocations(lineLevelOnly: false) { targetType discountedAmount { amount currencyCode } }
        } }
      }
      userErrors { message } warnings { code message }
    }
  }`;
  return {activeCart, identity, fingerprint, codes, input, amounts, query};
})();
if (typeof module !== 'undefined') module.exports = CftBagCore;
